import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LookBookAlbumPreviewComponent } from './album/look-book-album-preview/look-book-album-preview.component';
import { ButtonModule } from 'ZalamoLibrary/src/lib/ui/button/button/button.module';
import { MatIconModule } from '@angular/material/icon';
import { LanguageModule } from 'ZalamoLibrary/src/lib/zalamo/language/language.module';
import { AlbumSizeComponent } from './album/look-book-album-preview/album-size/album-size.component';
import { ListPickerComponent } from './album/look-book-album-preview/list-picker/list-picker.component';
import { ImagesModule } from 'ZalamoLibrary/src/lib/ui/images/images.module';
import { ZalamoTooltipModule } from 'ZalamoLibrary/src/lib/ui/zalamo-tooltip/zalamo-tooltip.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlbumDecorationComponent } from './album/look-book-album-preview/album-decoration/album-decoration.component';
import { FancyGraphicsModule } from 'ZalamoLibrary/src/lib/ui/fancy-graphics/fancy-graphics.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CheckboxModule } from 'ZalamoLibrary/src/lib/ui/form/checkbox/checkbox.module';
import { MatSelectModule } from '@angular/material/select';
import { ImageConfiguratorComponent } from './album/look-book-album-preview/image-configurator/image-configurator.component';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { CalcPriceForLookBookPipe } from './calc-price-for-look-book.pipe';
import { MatBadgeModule } from '@angular/material/badge';
import { ValueOfTheBasketDirective } from './value-of-the-basket.directive';
import { ProductPriceParserModule } from 'ZalamoLibrary/src/lib/ui/products/products-front/components/product-price-parser/product-price-parser.module';
import { CurrenciesModule } from 'ZalamoLibrary/src/lib/zalamo/currencies/currencies.module';
import { FormModule } from 'ZalamoLibrary/src/lib/ui/form/form.module';
import { ShoppingCartBackModule } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/shopping-cart-back.module';
import { PinchZoomModule } from 'ZalamoLibrary/src/lib/ui/ivypinch_pro/pinch-zoom.module';
import { ResponsivenessModule } from 'ZalamoLibrary/src/lib/ui/responsive/responsiveness/responsiveness.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SideDialogModule } from 'ZalamoLibrary/src/lib/ui/side-dialog';
import { DecorationsPreviewPipeModule } from 'ZalamoLibrary/src/lib/ui/look-book-front/decorations-preview-pipe/decorations-preview-pipe.module';
import { ImagesPickerComponent } from './album/look-book-album-preview/images-picker/images-picker.component';
import { LookBookAlbumImageEditorComponent } from './album/look-book-album-preview/images-picker/look-book-album-image-editor/look-book-album-image-editor.component';
import { WallDecorFrontModule } from 'ZalamoLibrary/src/lib/ui/look-book-front/wall-decor-front/wall-decor-front.module';
import { ImageLoaderModule } from 'ZalamoLibrary/src/lib/core/image/image-loader/image-loader.module';
import { LookBookProductPreviewsService } from 'ZalamoLibrary/src/lib/ui/look-book-front/look-book-product-previews.service';
import { LookBookSingleTriplexPreviewPipe } from './look-book-single-triplex-preview.pipe';
import { ProductConfigDrawerModule } from '@ui/products/products-front/components/config-drawer/product-config-drawer/product-config-drawer.module';
import { LookBookMissingPersonalizationPickerComponent } from './look-book-missing-personalization-picker/look-book-missing-personalization-picker.component';

@NgModule({
  declarations: [
    LookBookAlbumPreviewComponent,
    AlbumSizeComponent,
    ListPickerComponent,
    AlbumDecorationComponent,
    ImageConfiguratorComponent,
    CalcPriceForLookBookPipe,
    ValueOfTheBasketDirective,
    ImagesPickerComponent,
    LookBookAlbumImageEditorComponent,
    LookBookSingleTriplexPreviewPipe,
    LookBookMissingPersonalizationPickerComponent,
  ],
  exports: [
    LookBookAlbumPreviewComponent,
    ValueOfTheBasketDirective,
    LookBookSingleTriplexPreviewPipe,
    ImagesPickerComponent,
  ],
  imports: [
    CommonModule,
    ButtonModule,
    MatIconModule,
    LanguageModule,
    ImagesModule,
    ZalamoTooltipModule,
    ReactiveFormsModule,
    FancyGraphicsModule,
    MatFormFieldModule,
    MatInputModule,
    CheckboxModule,
    MatSelectModule,
    MatButtonModule,
    RouterModule,
    MatBadgeModule,
    ShoppingCartBackModule,
    // ProductsFrontModule,
    ProductPriceParserModule,
    CurrenciesModule,
    FormsModule,
    FormModule,
    PinchZoomModule,
    ResponsivenessModule,
    MatProgressBarModule,
    MatTooltipModule,
    SideDialogModule,
    DecorationsPreviewPipeModule,
    WallDecorFrontModule,
    ImageLoaderModule,
    ProductConfigDrawerModule,
  ],
  providers: [LookBookProductPreviewsService],
})
export class LookBookFrontModule {
  constructor() {
    console.log(`

    LOOK BOOK SERVICE IMPORTED

    `);
  }
}
